<app-default-layout
  [title]="'STANDARD.ATTRIBUTION'|translate"
  [noHeaderMargin]="true"
>
  <div class="row justify-between">
    <div class = "col-md-10 offset-md-1">
      <h4>{{'STANDARD.ATTRIBUTION'|translate}}</h4>
      Darstellung von Landkarten
      <a class="text-reset fw-bold" style=text-decoration:none href="https://github.com/Leaflet/Leaflet/blob/main/LICENSE"
         data-cy="nav-item-home">© Leaflet, BSD-2-Lizenz</a>
      <br>
      Landkartendaten
      <a class="text-reset fw-bold" style=text-decoration:none href="https://www.openstreetmap.org/copyright"
         data-cy="nav-item-home">© OpenStreetMap, ODbL-Lizenz</a>
      <br>
      Geo-Services
      <a class="text-reset fw-bold" style=text-decoration:none href="https://openrouteservice.org/terms-of-service/#/attribution"
         data-cy="nav-item-home">© openrouteservice.org by HeiGIT, CC-BY 4.0</a>
      <br>
      Icons
      <a class="text-reset fw-bold" style=text-decoration:none href="https://github.com/FortAwesome/Font-Awesome"
         data-cy="nav-item-home">© Font Awesome Free, CC-BY 4.0, SIL OFL 1.1, MIT</a>
      <br>
      Liberation Sans Font
      <a class="text-reset fw-bold" style=text-decoration:none href="https://github.com/liberationfonts/liberation-fonts/blob/main/LICENSE"
         data-cy="nav-item-home">© 2012 Red Hat, Inc., SIL OFL 1.1</a>
    </div>
  </div>
</app-default-layout>
